import config from '../../config';

const apiUrl = config.apiUrl;

const getAuthHeader = () => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    Authorization: `Bearer ${accessToken}`,
    'Content-Type': 'application/json',
  };
};

export const studentsService = {
  async exportStudents(): Promise<Blob> {
    const response = await fetch(`${apiUrl}/teachers/exportstudents`, {
      method: 'POST',
      headers: getAuthHeader(),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to export students data');
    }

    return await response.blob();
  },

  async getMyStudents(): Promise<TeacherStudentInfo[]> {
    const response = await fetch(`${apiUrl}/teachers/myStudents`, {
      headers: getAuthHeader(),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch students data');
    }

    const data = await response.json();
    return data.data || [];
  },

  async toggleStudentAttestation(studentId: number, subjectId: number): Promise<boolean> {
    const response = await fetch(`${apiUrl}/teachers/toggleStudentAttestation?studentId=${studentId}&subjectId=${subjectId}`, {
      method: 'POST',
      headers: getAuthHeader(),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to toggle student attestation');
    }

    const data = await response.json();
    return data.data;
  },
};

export interface StudentAttestationInfo {
  attestation: boolean | null;
  attestationDate: string | null;
  attestationTeacherName: string | null;
}

export interface TeacherStudentInfo {
  specialityId: number;
  specialityName: string | null;
  specialityNameEn: string | null;
  semester: number;
  subjectId: number;
  subjectName: string | null;
  studentId: number;
  facultyNumber: string | null;
  studentFirstName: string;
  studentMiddleName: string | null;
  studentLastName: string | null;
  studentGroupName: string | null;
  studentEmail: string | null;
  attestationInfo: StudentAttestationInfo | null;
} 